<template>
	<div>
		<Header />

		<div class="mainContent">
			<div style="text-align: right;">
				<router-link tag="p" class="history" to="/productDesignHistory">查看历史记录</router-link>
			</div>

			<div v-if="base">
				<ul class="baseInfo">
					<li>
						<label for="productName">公司名称：</label>
						<div>
							<Input autocomplete="off" v-model="basicInformation.companyName" size="large" placeholder="请输入"
								@on-keyup="fuzzyQuery" />
							<div id="getCompanyNameList">
								<p v-for="(item,i) in getCompanyNameList" :key="i" :data-area="item.base"
									@click="checkedName(item.name,item.base)">
									{{item.name}}
								</p>
							</div>
						</div>
					</li>
					<li>
						<label for="productName">所属行业：</label>
						<div style="display: flex;justify-content: space-between;">
							<div class="firstIndustry">
								<Select v-model="basicInformation.industry" @on-change="industryChange" size="large">
									<Option v-for="(item,i) in firstIndustry" :value="item.name" :key="i">
										{{ item.name }}
									</Option>
								</Select>
							</div>
							<div class="secondIndustry">
								<Select v-model="basicInformation.industryChild" @on-change="secondIndustryChange" size="large">
									<Option v-for="(item,i) in secondIndustry" :value="item.name" :key="i">
										{{ item.name }}
									</Option>
								</Select>
							</div>
						</div>
					</li>
					<li>
						<label for="productName">企业所在地：</label>
						<div>
							<Select v-model="basicInformation.location" size="large">
								<Option v-for="(item,i) in location" :value="item.value" :key="i">
									{{ item.value }}
								</Option>
							</Select>
						</div>
					</li>
					<li>
						<label for="productName">预计上架：</label>
						<div>
							<Select size="large" v-model="basicInformation.listing">
								<Option v-for="(item,i) in productSource" :value="item" :key="i">
									{{ item }}
								</Option>
							</Select>
						</div>
					</li>
					<li style="width: 100%;">
						<div class="scenario">
							<Input class="textarea" v-model="basicInformation.dateResourceDes" type="textarea" :autosize="true"
								placeholder="请描述主营业务及数据情况简介" />

							<p :class="['save',loading?'disabled':'']">
								<img src="../../assets/img/tableEntryService/up.png" alt="上传" @click="save"
									:style="{'pointerEvents':loading?'none':'initial'}" />
							</p>

						</div>
					</li>
				</ul>
			</div>

			<div class="aiConversation">
				<div class="flow" v-if="loading">
					<img src="../../assets/img/tableEntryService/su.png" alt="苏征宇" />
					<div>
						<p class="bold" style="display: inline-block;">数据产品设计中，请耐心等待</p>
						<img src="../../assets/img/tableEntryService/loading.gif" alt=""
							style="height: 70px;vertical-align: middle;" />
					</div>
				</div>
				<div class="flow" v-if="chat1">
					<img src="../../assets/img/tableEntryService/su.png" alt="苏征宇" />
					<div>
						<p class="bold">智能数据产品设计助手</p>
						<p>输入数据资源描述与应用场景，智能匹配模板生成数据产品</p>
					</div>
				</div>
				<div class="user" v-if="chat2">
					<div>
						<ul>
							<li>
								<span>公司名称：</span>
								<span>{{basicInformation.companyName}}</span>
							</li>
							<li>
								<span>所属行业：</span>
								<span>{{basicInformation.industry+'-'+basicInformation.industryChild}}</span>
							</li>
							<li>
								<span>企业所在地：</span>
								<span>{{basicInformation.location}}</span>
							</li>
							<li>
								<span>预计上架：</span>
								<span>{{basicInformation.listing}}</span>
							</li>
							<li>
								<span>主营业务及数据情况简介：</span>
								<span>{{basicInformation.dateResourceDes}}</span>
							</li>
						</ul>
					</div>
					<img :src="setImg('tableEntryService/user','png')" alt="用户" />
				</div>
				<div class="flow" v-if="chat3">
					<img src="../../assets/img/tableEntryService/su.png" alt="苏征宇" />
					<div>
						<p>以下信息是根据用户提供的信息，结合大语言模型和行业案例库自动生成，仅供参考，想了解详细数据资源入表流程及产品规划，请联系心流慧估客服：17610076778（微信同号）</p>
					</div>
				</div>
				<div class="flow" v-if="chat4">
					<img src="../../assets/img/tableEntryService/su.png" alt="苏征宇" />
					<div style="height: 60px;position: relative;top: 15px;">
						<span>我还可以为数据产品定价</span>
						<span class="buttonFill pricing" @click="productEntrance('','98')">立即定价</span>
					</div>
				</div>
			</div>

			<div class="dataIntroduce" v-if="chat5">

				<div v-for="(design,idx) in allData">
					<div v-if="design.type===0">
						<p class="title">{{setChineseNum(idx)}}、数据产品</p>
						<div class="listVotedProjects">
							<ul class="boxhead">
								<li>
									<div>数据产品名称</div>
									<div>产品描述</div>
									<div>主要数据源</div>
									<div>潜在价值与应用</div>
									<div>入表形态</div>
								</li>
							</ul>
							<ul class="listInfo">
								<li v-for="(item,i) in design.data" :key="'structure'+i">
									<div>{{item.productName}}</div>
									<div>{{item.productDes}}</div>
									<div>{{item.field.join('、')}}</div>
									<div>{{item.application}}</div>
									<div>{{item.productType}}</div>
								</li>
							</ul>
						</div>
					</div>


					<div v-if="design.type===2">
						<p class="title">{{setChineseNum(idx)}}、所在地（{{basicInformation.location}}）奖励政策</p>
						<ul class="dataText">
							<li v-for="(item,i) in design.data" :key="'policy'+i">
								<i class="bold">{{item.title}}：</i>
								<i>{{item.content}}</i>
							</li>
						</ul>
					</div>

					<div v-if="design.type===3">
						<p class="title">{{setChineseNum(idx)}}、上架交易中心（{{basicInformation.listing}}）要求</p>
						<ul class="claim">
							<li v-for="(item,i) in design.data" :key="'claim'+i">
								<p class="title">{{item.title}}</p>
								<div v-if="typeof item.content=='object'" style="margin-bottom: 20px;">
									<div v-for="(second,s) in item.content" :key="'second'+s">

										<div v-if="isStringObject(second)" class="fontSize14 2leve">{{second}}</div>

										<div v-else>
											<p class="secondTitle" v-if="second.title">{{second.title}}</p>

											<div v-if="typeof second.content=='object'" style="margin-bottom: 20px;">
												<div v-for="(three,t) in second.content" :key="'three'+t">
													<div v-if="isStringObject(three)" class="fontSize14 3leve">{{three}}</div>
													<div v-else>
														<p class="fontSize14 3leve" v-if="three.title">{{three.title}}</p>

														<div v-if="typeof three.content=='object'" style="margin-bottom: 10px;">
															<div v-for="(four,f) in three.content" :key="'four'+f" class="leve4">
																{{four}}
															</div>
														</div>
														<p v-else class="leve4" style="margin-bottom: 10px;">{{three.content}}</p>
													</div>

													<div v-if="three.files&&three.files.length>0" class="fileImgs">
														<p v-for="(threeImg,thIdx) in three.files" :key="'threeImg'+thIdx"
															@click="openFile(threeImg)">
															<img :src="require('@/assets/img/tableEntryService/'+getExtension(threeImg)+'.png')" />
															<span>{{threeImg}}</span>
														</p>
													</div>
												</div>
											</div>
											<p v-else class="text">{{second.content}}</p>

										</div>



										<div v-if="second.files&&second.files.length>0" style="margin-bottom: 10px;" class="fileImgs">
											<p v-for="(secondImg,sIdx) in second.files" :key="'secondImg'+sIdx" @click="openFile(secondImg)">
												<img :src="require('@/assets/img/tableEntryService/'+getExtension(secondImg)+'.png')" />
												<span>{{secondImg}}</span>
											</p>
										</div>
									</div>
								</div>
								<p v-else class="text">{{item.content}}</p>

								<div v-if="item.files&&item.files.length>0" style="margin-bottom: 10px;" class="fileImgs">
									<p v-for="(firstImg,fIdx) in item.files" :key="'firstImg'+fIdx" @click="openFile(firstImg)">
										<img :src="require('@/assets/img/tableEntryService/'+getExtension(firstImg)+'.png')" />
										<span>{{firstImg}}</span>
									</p>
								</div>
							</li>
						</ul>
					</div>


					<div v-if="design.type===4">
						<p class="title">{{setChineseNum(idx)}}、参考数据产品案例</p>
						<ul class="caseList">
							<li v-for="(item,i) in design.data" :key="i">
								<div class="name">
									<span class="content-tit">{{item.productName}}</span>
									<span class="index_type">{{item.productType}}</span>
								</div>

								<p class="index_desc">{{item.productIntroduction}}</p>

								<p class="orgName">{{item.orgName}}</p>

								<router-link tag="div" class="index_detailbtn"
									:to="{ path: '/caseProduct', query: { id:item.id } }">查看详情</router-link>
							</li>
						</ul>
					</div>

					<div v-if="design.type===5">
						<p class="title">{{setChineseNum(idx)}}、数据产品风险提示</p>
						<div v-for="(risk,r) in design.data" :key="'risk'+r">
							<p class="riskTitle">{{risk.riskType}}</p>
							<ul class="dataText">
								<li v-for="(item,i) in risk.riskList" :key="'riskItem'+i">
									<i class="bold">{{item.riskTitle}}：</i>
									<i>{{item.riskContent}}</i>
								</li>
							</ul>
						</div>

					</div>
				</div>

			</div>


		</div>


		<Modal v-model="model" :mask-closable="false" title="提示">
			<p style="font-size: 16px;">{{markedWords}}</p>
		</Modal>

		<SignUp />
		<Footer />
	</div>
</template>

<script>
	import Header from '../../common/header/flow_header.vue'
	import Footer from '../../common/footer.vue'
	import publicMethod from '../publicMethod'
	import SignUp from '@/components/signUp/index.vue'
	import tsconfig from '@/assets/js/tsconfig.json';

	import qs from 'qs'

	import {
		merge
	} from 'lodash'

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer,
			SignUp
		},
		data() {
			return {
				url: this.domain.testUrl + this.domain.valuationProject,
				model: false,
				markedWords: '',
				inputTimer: null,
				getCompanyNameList: [],
				firstIndustry: [],
				secondIndustry: [],
				location: tsconfig.base.location, //企业所在地
				productSource: [],
				basicInformation: {
					id: '',
					companyName: '',
					industry: '', // 一级行业
					industryChild: '', //二级行业
					location: '',
					dateResourceDes: '',
					listing: '' //预计上架

				},
				chat1: false,
				chat2: false,
				chat3: false,
				chat4: false,
				chat5: false,
				base: true,
				timer: null,
				loading: false,
				productData: [],
				structure: [], //数据产品基本信息
				application: [], //应用场景
				policy: [], //政策
				allData: [],
				checkedCompanyName: '', //模糊查询列表中选中的公司名称
				reportMatchId: ''



			}
		},
		mounted() {
			this.getDataDesignDetail()
			this.getExchangeList()

		},
		beforeDestroy() {
			// 组件销毁前清理定时器
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
		},
		watch: {
			// '$route'(to, from) {
			// 	// 对路由变化作出反应
			// 	console.log('路由参数变化', to);

			// 	if (!to.query.id) {
			// 		this.getDataDesignDetail()
			// 	}

			// },
			checkedCompanyName: {
				handler: function(newValue, oldValue) {
					if (newValue && !this.basicInformation.id) {
						this.fetchData(newValue)
					}
				},
				deep: true
			}

		},
		methods: {
			setChineseNum(index) {
				switch (index) {
					case 0:
						var str = "一";
						break;
					case 1:
						var str = "二";
						break;
					case 2:
						var str = "三";
						break;
					case 3:
						var str = "四";
						break;
					case 4:
						var str = "五";
						break;
					case 5:
						var str = "六";
						break;
				}
				return str
			},
			isStringArray(arr) {
				return Array.isArray(arr) && arr.every(item => typeof item === 'string');
			},
			isStringObject(data) {
				return typeof data === 'string'
			},
			getExtension(filename) {
				return filename.split('.').pop().toLowerCase();
			},
			openFile(file) {
				window.open('https://www.flcccc.com/flow/dataAsset/uploadImg/dataProductDesign/files/' + file)
			},
			setShow() {
				// 确保之前的定时器被清理
				if (this.timer) {
					clearInterval(this.timer);
				}
				
				// 重置所有chat状态
				for (let i = 1; i <= 5; i++) {
					this['chat' + i] = false;
				}
				
				// 使用let声明变量，避免闭包问题
				let i = 0;
				this.timer = setInterval(() => {
					i++;
					
					// 确保数据存在再显示
					if (i <= 5) {
						this['chat' + i] = true;
					} else {
						// 所有内容已显示，清理定时器
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 500);
				
				// 添加超时保护，确保定时器被清理
				setTimeout(() => {
					if (this.timer) {
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 3000);
			},
			oneIndustry(name) { //一级行业
				this.$post(this.url + 'industry/qryOneIndustry', qs.stringify({
						listedCode: 4
					}))
					.then((res) => {
						this.firstIndustry = res.data.content;
						if (name) {
							this.industryChange(name)
						}
					});
			},
			industryGroup(code, name) {
				this.$post(this.url + 'industry/qryTwoIndustry', qs.stringify({
						industryCode: code
					}))
					.then((res) => {
						this.secondIndustry = res.data.content;
					});

			},
			getExchangeList() {
				this.$post(this.url + 'dataProductDesign/getExchangeList', qs.stringify({}))
					.then(res => {
						this.productSource = res.data.content

					})
			},
			industryChange(val) {
				for (var i = 0; i < this.firstIndustry.length; i++) {
					if (val == this.firstIndustry[i].name) {

						this.industryGroup(this.firstIndustry[i].code, '')
						break;
					}
				}

			},
			secondIndustryChange(val) {
				for (var i = 0; i < this.secondIndustry.length; i++) {
					if (val == this.secondIndustry[i].name) {
						break;
					}
				}
			},
			getCompanyName(name) {
				this.$post(this.url + 'baseInfo/getCompanyName', qs.stringify({
						companyName: name
					}))
					.then((res) => {
						this.getCompanyNameList = res.data.content
					});
			},
			escapeRegExp(string) { //转义特殊字符
				return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
			},
			fuzzyQuery() {
				var this_ = this;
				var text = this_.escapeRegExp(this_.basicInformation.companyName);
				var regex = new RegExp(text)

				if (regex.test(this_.basicInformation.companyName)) {
					clearTimeout(this_.inputTimer);
					this_.inputTimer = setTimeout(function() { //阻止input方法执行两次
						console.log('中文输入已完成');

						if (this_.basicInformation.companyName.length >= 4 && this_.basicInformation.companyName.length < 20) {
							this_.getCompanyName(this_.basicInformation.companyName)
						}

					}, 100); // 设置一个适当的延迟时间

				} else {
					// 中文输入未完成
					console.log('中文输入未完成');
					if (this_.basicInformation.companyName.length == 0) {
						$('#getCompanyNameList').html('');
					}
				}
			},
			checkedName: function(name, base) {
				this.checkedCompanyName = name
				this.basicInformation.companyName = name
				this.basicInformation.area = base
				$('#getCompanyNameList').html('');
			},
			fetchData: function(name) {
				this.$post(this.url + 'valuationReport/getBaseInfoByCompanyName', qs.stringify({
						name: name ? name : this.basicInformation.companyName,
						stage: '',
						type: ''
					}))
					.then((res) => {
						var defaultDataKey = Object.keys(this.basicInformation)
						if (res.data.code == 200 && res.data.content != null) {
							// dataSource ：0官网   1用友
							var content = res.data.content;

							if (content.industryName) {
								this.basicInformation.industry = content.industryName
								this.basicInformation.industryChild = content.industryChildName

								this.oneIndustry(this.basicInformation.industry)
								this.industryChange(this.basicInformation.industry)
							}

							if (content.area) {
								this.basicInformation.location = content.area
							}

						}

					});
			},
			save() {

				if (!this.basicInformation.companyName) {
					this.model = true;
					this.markedWords = '请输入公司名称';
					return
				}
				if (!this.basicInformation.industry) {
					this.model = true;
					this.markedWords = '请选择一级行业';
					return
				}
				if (!this.basicInformation.industryChild) {
					this.model = true;
					this.markedWords = '请选择二级行业';
					return
				}
				if (!this.basicInformation.location) {
					this.model = true;
					this.markedWords = '请选择企业所在地';
					return
				}

				if (!this.basicInformation.listing) {
					this.model = true;
					this.markedWords = '请选择预计上架';
					return
				}
				if (!this.basicInformation.dateResourceDes) {
					this.model = true;
					this.markedWords = '请输入数据资源及应用场景';
					return
				}

				this.loading = true

				this.$post(this.url + 'dataProductDesign/saveDataDesign', qs.stringify({
					dataDesign: JSON.stringify(this.basicInformation)
				})).then(res => {
					if (res.data.code == 200) {
						this.loading = false
						this.$router.push({
							query: merge({}, this.$route.query, {
								id: res.data.content.id
							})
						})

						this.basicInformation.productName = res.data.content.productName
						this.basicInformation.id = res.data.content.id

						this.aiData(res.data.content)

						// 添加短暂延迟确保数据完全加载
						this.$nextTick(() => {
							this.setShow()
						})

					}

				})

			},
			getDataDesignDetail() {
				this.$post(this.url + 'dataProductDesign/getDataDesignDetail', qs.stringify({
						designId: this.$route.query.id ? this.$route.query.id : ''
					}))
					.then((res) => {
						if (res.data.content) {
							this.basicInformation = res.data.content

							this.oneIndustry(this.basicInformation.industry)
							this.aiData(res.data.content)
							if (!this.$route.query.details) {
								// 添加短暂延迟确保数据完全加载
								this.$nextTick(() => {
									this.setShow()
								})
							}
						} else {
							this.oneIndustry()
							this.basicInformation = {
								id: '',
								companyName: '',
								industry: '', // 一级行业
								industryChild: '', //二级行业
								location: '',
								dateResourceDes: '',
								listing: '' //预计上架
							}

							for (var i = 1; i < 6; i++) {
								this['chat' + i] = false
							}
						}

						if (this.$route.query.details == 1) {
							this.base = false
							for (var i = 1; i < 6; i++) {
								this['chat' + i] = true
							}
						} else {
							this.base = true
						}


					});

			},
			aiData(data) {
				this.allData = []
				this.allData.push({
					type: 0,
					data: JSON.parse(data.structure)
				})

				// this.allData.push({
				// 	type: 1,
				// 	data: JSON.parse(data.application)
				// })

				if (data.policy && JSON.parse(data.policy).length > 0) {
					this.allData.push({
						type: 2,
						data: JSON.parse(data.policy)
					})
				}

				if (data.requirements && JSON.parse(data.requirements).length > 0) {
					this.allData.push({
						type: 3,
						data: JSON.parse(data.requirements)
					})
				}

				if (data.productCase && JSON.parse(data.productCase).length > 0) {
					this.allData.push({
						type: 4,
						data: JSON.parse(data.productCase)
					})
				}

				if (data.risk && JSON.parse(data.risk).length > 0) {
					this.allData.push({
						type: 5,
						data: JSON.parse(data.risk)
					})
				}

			}


		}

	}
</script>

<style scoped lang="less">
	.history {
		font-size: 20px;
		font-weight: bold;
		margin-top: 30px;
		color: #282828;
		cursor: pointer;
		display: inline-block;
	}

	.history:hover {
		color: var(--mainColor);
		text-decoration: underline;
	}

	.baseInfo {
		margin-top: 30px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		>li {
			display: flex;
			align-items: center;
			margin-bottom: 20px;

			label {
				width: 110px;
				font-size: 16px;
				color: #282828;
			}

			label+div {
				width: 450px;
			}

			.scenario {
				width: 100%;
				min-height: 150px;
				padding: 10px 10px 80px;
				border: 1px solid #dcdee2;
				border-radius: 4px;
				position: relative;

				>.save {
					width: 50px;
					height: 50px;
					line-height: 50px;
					background: var(--mainColor);
					text-align: center;
					font-size: 16px;
					border-radius: 50%;
					position: absolute;
					bottom: 20px;
					right: 20px;
					box-shadow: none;
					border: none;
					cursor: pointer;

					img {
						width: 40px;
						position: relative;
						top: 4px;
					}
				}

				>.save:hover {
					background: var(--complementaryColors);
				}

				>.save.disabled {
					background: rgb(247, 247, 247) !important;
					cursor: no-drop !important;
				}

			}

		}

	}

	.firstIndustry,
	.secondIndustry {
		width: 47%;
	}

	/deep/ .ivu-input-type-textarea .ivu-input {
		min-height: 100px;
		border: none;
		outline: none;
		box-shadow: none;
		resize: none;
		font-size: 16px;
	}

	/deep/ .ivu-input {
		color: #282828;
	}

	.bold {
		font-weight: bold;
	}

	.aiConversation {
		margin: 30px auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		>div {
			width: 100%;
			display: flex;
			margin-bottom: 20px;

			>img {
				width: 90px;
				height: 90px;
				border-radius: 50%;
				object-fit: cover;
			}


		}

		.pricing {
			padding: 0 15px;
			margin-left: 10px;
			border-radius: 15px;
		}

		.flow {
			>img {
				object-position: top;
				border: 2px solid var(--mainColor);
				margin-right: 30px;
			}

			>div {
				max-width: 600px;
				line-height: 30px;
				border-radius: 0 15px 15px 15px;
				border: 2px solid var(--mainColor);
				padding: 10px 20px;
				font-size: 16px;
				color: #282828;
				text-align: justify;
			}
		}

		.user {
			justify-content: flex-end;

			>img {
				margin-left: 20px;
			}

			>div {
				max-width: 560px;
				padding: 10px 20px;
				background: var(--mainColor);
				border-radius: 15px 0 15px 15px;
				font-size: 16px;
				color: #fff;

				ul {
					li {
						margin-bottom: 5px;

						span {
							vertical-align: top;
						}

					}
				}
			}
		}

	}

	.dataIntroduce {
		>div {
			margin-bottom: 40px;
		}

		.title {
			font-weight: bold;
			font-size: 20px;
			color: var(--mainColor);
			margin-bottom: 19px;
		}

		.subheading {
			font-weight: bold;
			font-size: 18px;
			color: var(--mainColor);
			margin-bottom: 19px;
		}
	}

	.boxhead {
		background: var(--mainColor);
	}

	.boxhead li>div:not(:last-child) {
		border-right: 1px solid #fff;
	}

	.boxhead li,
	.listInfo li {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.boxhead li>div {
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 16px;
		font-weight: bold;
		color: #fff;
		box-sizing: border-box;
	}

	.listInfo {
		margin-top: 10px;
	}

	.listInfo li>div {
		min-height: 60px;
		line-height: 20px;
		font-size: 14px;
		color: #282828;
		text-align: center;
		padding: 10px;
		box-sizing: border-box;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}


	.listInfo li {
		box-shadow: 0px 0px 13px 0px rgba(86, 136, 205, 0.23);
		margin-bottom: 10px;
	}

	.listInfo li>div:not(:last-child)::after {
		content: '';
		display: block;
		width: 1px;
		height: 34px;
		background: #E0E0E0;
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.listVotedProjects li>div:nth-of-type(1) {
		width: 11%;
	}

	.listVotedProjects li>div:nth-of-type(2) {
		width: 27%;
	}

	.listVotedProjects li>div:nth-of-type(3) {
		width: 30%;
	}

	.listVotedProjects li>div:nth-of-type(4) {
		width: 22%;
	}

	.listVotedProjects li>div:nth-of-type(5) {
		width: 10%;
	}

	.dataText {
		li:not(:last-child) {
			margin-bottom: 15px;
		}

		li {
			font-size: 14px;
			color: #000;
			line-height: 25px;
			vertical-align: top;

			i {
				display: inline;
			}
		}
	}

	.fontSize14 {
		font-size: 14px;
		line-height: 24px;
		color: #282828;
		padding-left: 10px;
	}

	.claim {
		width: 100%;

		.title {
			font-weight: bold;
			font-size: 18px;
			color: var(--mainColor);
			margin-bottom: 15px;
		}

		.text {
			font-size: 14px;
			color: #282828;
			line-height: 24px;
			padding-left: 10px;
			text-align: justify;
			margin-bottom: 20px;
		}

		.secondTitle {
			font-size: 16px;
			color: var(--mainColor);
			line-height: 24px;
			padding-left: 10px;
			margin-bottom: 10px;
		}

		.leve4 {
			font-size: 14px;
			line-height: 24px;
			color: #282828;
			padding-left: 22px;
		}

		.fileImgs {
			padding-left: 10px;

			p {
				margin-bottom: 20px;
				font-size: 14px;
				color: #282828;
				cursor: pointer;

				span {
					text-decoration: underline;
				}
			}

			p:hover {
				color: var(--mainColor);
			}

			img {
				height: 30px;
				vertical-align: middle;
				margin-right: 10px;
			}
		}

	}

	.caseList {
		li {
			height: 182px;
			padding: 20px 5px 20px 20px;
			border: 2px solid #FFFFFF;
			box-shadow: 2px 2px 13px 0px rgba(32, 76, 151, 0.23);
			overflow: hidden;
			cursor: pointer;
			margin-bottom: 30px;
			position: relative;

			.name {
				display: flex;
				align-items: center;
				width: 100%;
				margin-bottom: 18px;
			}

			.content-tit {
				max-width: 900px;
				font-size: 18px;
				font-weight: bold;
				color: #282828;
				margin-right: 20px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.index_type {
				height: 24px;
				line-height: 24px;
				text-align: center;
				padding: 0 10px;
				background: #f4f6f9;
				border: 1px solid #e5e6eb;
				color: #282828;
			}

			.index_desc {
				width: 70%;
				line-height: 22px;
				font-size: 14px;
				color: #666666;
				text-align: justify;
				margin-bottom: 10px;
				-webkit-line-clamp: 2;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.orgName {
				font-size: 14px;
				color: #999999;
				position: absolute;
				bottom: 20px;
				left: 20px;
			}

			.index_detailbtn {
				width: 142px;
				height: 36px;
				line-height: 36px;
				background: var(--mainColor);
				font-size: 14px;
				color: #FFF;
				text-align: center;
				cursor: pointer;
				position: absolute;
				right: 20px;
				top: 50%;
				transform: translateY(-50%);
			}

		}

	}

	.riskTitle {
		font-size: 18px;
		color: var(--mainColor);
		line-height: 24px;
		font-weight: bold;
		margin-top: 20px;
		margin-bottom: 10px;
	}
</style>